module.exports = __webpack_public_path__ + "img/logo-dark.0642da7e.png";